/**
 * @description
 * Objeto AvisCategoria
 */

export class AvisCategoria {
    public id:number = null;
    public code:string = "";
    public descript:string = "";

    constructor() {}
}